import { CustomTooltip } from 'src/components/CustomTooltip';
import { CustomTypography } from 'src/components/CustomTypography';
import { FieldSelect } from 'src/components/FieldSelect';
import { FieldSelectMenuItem } from 'src/components/FieldSelectMenuItem';
import { CASING_LABELS, CASING_TYPE } from 'src/data/generation';
import { CAPITALIZATION_LABEL } from 'src/data/project';

import { useStyles } from './useStyles';

const CASES_TOOLTIP = {
  [CASING_TYPE.sentence]: 'This is a sample text',
  [CASING_TYPE.title]: 'This Is A Sample Text',
  [CASING_TYPE.upper]: 'THIS IS A SAMPLE TEXT',
};

const MENU_PROPS = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
};

export const FieldCases = ({ casing, onChange, onOpen, onClose }) => {
  const styles = useStyles({});

  const localCasing = casing || CASING_TYPE.default;

  return (
    <FieldSelect
      className={styles.root}
      classes={{ select: styles.select, menuPaper: styles.menuPaper }}
      headerClasses={{ label: styles.label }}
      label={CAPITALIZATION_LABEL}
      value={localCasing}
      onChange={onChange}
      onClose={onClose}
      onOpen={onOpen}
      renderValue={(selectedValue) => (
        <CustomTypography>{CASING_LABELS[selectedValue]}</CustomTypography>
      )}
      MenuProps={MENU_PROPS}
    >
      {Object.values(CASING_TYPE).map((key) => {
        const tooltipProps = { title: CASES_TOOLTIP[key], placement: 'right' };
        if (key === CASING_TYPE.default) {
          tooltipProps.open = false;
        }
        return (
          <CustomTooltip
            key={key}
            {...tooltipProps}
          >
            <FieldSelectMenuItem
              key={key}
              value={key}
            >
              {CASING_LABELS[key]}
            </FieldSelectMenuItem>
          </CustomTooltip>
        );
      })}
    </FieldSelect>
  );
};
